import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { Slider as Slider$1, Rail, ActiveRangeRail, Draggable, Handle } from './styled.es.js';
import { useSlider } from './useSlider.es.js';
import { useDrag } from './useDrag.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var DragHandle = function DragHandle(_a) {
  var _b = _a,
      position = _b.position,
      radius = _b.radius,
      onChange = _b.onChange,
      onChangeEnd = _b.onChangeEnd,
      minPosition = _b.minPosition,
      maxPosition = _b.maxPosition,
      defaultPosition = _b.defaultPosition,
      isDisabled = _b.isDisabled,
      props = __objRest(_b, ["position", "radius", "onChange", "onChangeEnd", "minPosition", "maxPosition", "defaultPosition", "isDisabled"]);

  var _useDrag = useDrag({
    position: position,
    minPosition: minPosition,
    maxPosition: maxPosition,
    defaultPosition: defaultPosition,
    onChange: onChange,
    onChangeEnd: onChangeEnd,
    isDisabled: isDisabled
  }),
      currentPosition = _useDrag.currentPosition,
      isDragging = _useDrag.isDragging,
      handleMouseDown = _useDrag.handleMouseDown,
      handleTouchStart = _useDrag.handleTouchStart;

  return (
    /* @__PURE__ */
    React.createElement(Draggable, __spreadValues({
      onMouseDown: handleMouseDown,
      onTouchStart: handleTouchStart,
      radius: radius,
      position: currentPosition,
      isDragging: isDragging
    }, props),
    /* @__PURE__ */
    React.createElement(Handle, {
      radius: radius,
      isDisabled: isDisabled
    }))
  );
};

var Slider = forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      _a$width = _a.width,
      width = _a$width === void 0 ? 300 : _a$width,
      onChange = _a.onChange,
      onChangeEnd = _a.onChangeEnd,
      min = _a.min,
      max = _a.max,
      _a$hasRange = _a.hasRange,
      hasRange = _a$hasRange === void 0 ? false : _a$hasRange,
      _a$handleRadius = _a.handleRadius,
      handleRadius = _a$handleRadius === void 0 ? 10 : _a$handleRadius,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      defaultValue = _a.defaultValue,
      value = _a.value,
      as = _a.as,
      rest = __objRest(_a, ["children", "width", "onChange", "onChangeEnd", "min", "max", "hasRange", "handleRadius", "isDisabled", "defaultValue", "value", "as"]);

  var _useSlider = useSlider(props),
      positions = _useSlider.positions,
      minPosition = _useSlider.minPosition,
      maxPosition = _useSlider.maxPosition,
      updateMinFromPosition = _useSlider.updateMinFromPosition,
      updateMaxFromPosition = _useSlider.updateMaxFromPosition,
      onMinChangeEnd = _useSlider.onMinChangeEnd,
      onMaxChangeEnd = _useSlider.onMaxChangeEnd;

  return (
    /* @__PURE__ */
    React.createElement(Slider$1, __spreadValues({
      min: min,
      max: max,
      width: width,
      ref: ref,
      forwardedAs: as
    }, rest),
    /* @__PURE__ */
    React.createElement(Box, {
      display: "flex",
      width: "100%"
    },
    /* @__PURE__ */
    React.createElement(Rail, {
      isDisabled: isDisabled
    }), hasRange &&
    /* @__PURE__ */
    React.createElement(ActiveRangeRail, {
      handleRadius: handleRadius,
      range: {
        min: positions.min,
        max: positions.max
      },
      isDisabled: isDisabled
    }),
    /* @__PURE__ */
    React.createElement(DragHandle, {
      position: positions.min,
      radius: handleRadius,
      onChange: updateMinFromPosition,
      onChangeEnd: onMinChangeEnd,
      minPosition: minPosition,
      maxPosition: hasRange ? positions.max : maxPosition,
      defaultPosition: minPosition,
      isDisabled: isDisabled
    }), hasRange &&
    /* @__PURE__ */
    React.createElement(DragHandle, {
      position: positions.max,
      radius: handleRadius,
      onChange: updateMaxFromPosition,
      onChangeEnd: onMaxChangeEnd,
      minPosition: positions.min,
      maxPosition: maxPosition,
      defaultPosition: maxPosition,
      isDisabled: isDisabled
    })))
  );
});
Slider.displayName = "Slider";
export { Slider };